import { render, staticRenderFns } from "./MoveToStageBtn.vue?vue&type=template&id=204ae522&scoped=true&"
import script from "./MoveToStageBtn.vue?vue&type=script&lang=js&"
export * from "./MoveToStageBtn.vue?vue&type=script&lang=js&"
import style0 from "./MoveToStageBtn.vue?vue&type=style&index=0&id=204ae522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ae522",
  null
  
)

export default component.exports